export const ChartTooltip = ({ active, payload, label }: any) => {
    if (!active || !payload || payload.length === 0) return null;

    const formatValue = (value: number, key: string) => {
        if (key === 'revenue' || key === 'ecpm') {
            return new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'USD'
            }).format(value);
        } else if (key === 'impressions' || key === 'clicks') {
            return new Intl.NumberFormat('pt-BR').format(value);
        } else if (key === 'ctr') {
            return `${value.toFixed(2)}%`;
        }
        return value;
    };

    return (
        <div className="backdrop-blur-md bg-white/90 border border-gray-200 rounded-xl shadow-2xl p-4 min-w-[200px]">
            {/* Label da data */}
            <div className="font-semibold text-gray-900 pb-2 mb-2 border-b border-gray-200">
                {label}
            </div>

            {/* Métricas */}
            <div className="space-y-2">
                {payload.map((entry: any, index: number) => (
                    <div key={index} className="flex items-center justify-between gap-4">
                        <div className="flex items-center gap-2">
                            <div
                                className="w-2.5 h-2.5 rounded-full shadow-sm"
                                style={{ backgroundColor: entry.color }}
                            />
                            <span className="text-sm text-gray-600">{entry.name}</span>
                        </div>
                        <span className="text-sm font-bold text-gray-900">
                            {formatValue(entry.value, entry.dataKey)}
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );
};